import { render, staticRenderFns } from "./FrameInventory.vue?vue&type=template&id=07162bb4"
import script from "./FrameInventory.vue?vue&type=script&lang=js"
export * from "./FrameInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports